// eslint-disable-next-line no-unused-vars
import React from "react";

function ExternalRedirect({ path }) {
  window.location = path;
  return <></>;
}

export default ExternalRedirect;
